const EventConstants = {
	GET_EVENT: "GET_EVENT",
	ADD_EVENT: "ADD_EVENT",
	DELETE_EVENT: "DELETE_EVENT",
	UPDATE_EVENT: "UPDATE_EVENT",
};

export default EventConstants;
